// export anonymous function
export default (function () {
	document.addEventListener('DOMContentLoaded', function () {
		console.log('hi from main.js');
	});
})();
